import './App.css';


// React
import { useEffect,useState } from 'react';


// MUI Items Import
import { createTheme,ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CloudIcon from '@mui/icons-material/Cloud';
import Button from '@mui/material/Button';

// TRANSLATE
import { useTranslation } from 'react-i18next';
import "./i18next";

//  API
import axios from "axios";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/en-gb";

const theme = createTheme({
  typography:{
    fontFamily : ["IBM"],
  }
})


let cancelAxios = null

function App() {
  


  
  const { t , i18n } = useTranslation();
  
  // STATES
  const [locale,setLocaels] = useState("")
  const [dateAndTime,setDateAndTime] = useState("");
  const [temp,setTemp] = useState({
    Number:null,
    description:"",
    min:null,
    max:null,
  })

  //handle
  function handleLanguageClick(){
        if(locale == "en" ){
            i18n.changeLanguage('ar')
            setLocaels('ar')
            moment.locale('ar')
        }else{
          setLocaels('en')
          i18n.changeLanguage('en')
          moment.locale('en')
        }
        setDateAndTime(moment().format('MMMM Do YYYY, h:mm:ss a'))
      }
  useEffect(()=>{
    i18n.changeLanguage("en");
    setLocaels('en')
  },[])
  
  useEffect(()=>{
    setDateAndTime(moment().format('MMMM Do YYYY, h:mm:ss a'))
    
    // Make a request for a user with a given ID
    axios.get('https://api.openweathermap.org/data/2.5/weather?lat=30.466160&lon=31.179310&appid=687d607e7377effe25bea6af11aaf760',
      {
        cancelToken: new axios.CancelToken((c)=>{
          cancelAxios = c
        })
      }
      
    )
    .then(function (response) {
        // handle success

        const temp =  Math.round(response.data.main.temp - 272.15)

        const min  =  Math.round(response.data.main.temp_min - 272.15)

        const max  =  Math.round(response.data.main.temp_max - 272.15)

        const description = response.data.weather[0].description;
        
        const responseIcon = response.data.weather[0].icon;
        
        setTemp({
          Number:temp,
          min:min,
          max:max,
          description:description,
          icon: responseIcon
        })
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      
      return () => {
        console.log("cancling")
        cancelAxios();
      }
      
    },[])
    


  return (
      <ThemeProvider theme={theme}>
        <Container maxWidth="sm" >
            
            {/* CONTENT CONTAINER */}
            
            <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',flexDirection:'column'}}>


            {/* CARD */}
            <div 
            dir={locale == "ar" ? 'rtl' : 'ltr'}
            style={{
              width:'100%',
              background:'rgb(28 52 91 / 36%)',
              color:'white',
              padding:'10px',
              borderRadius:'15px',
              boxShadow:'0px 11px 1px rgba(0,0,0,0.05)'
              }}>

                {/* CONTENT */}

                <div>
                  {/* CUTY & TIME */}

                    <div style={{display:'flex',alignItems:'end',justifyContent:'start',gap:'40px'}}  >
                    
                        <Typography variant="h2" >
                            {t("banha")}
                        </Typography>

                        <Typography variant="h5" style={{marginRight:'20px'}} >
                          {dateAndTime}
                        </Typography>
                        
                    
                    </div>

                {/*=== CUTY & TIME ===*/}
                
                <hr/>
              
              
              <div style={{display:'flex',justifyContent:'space-around',flexDirection:'row-reverse'}} >
                
                {/* DGREE & DESCRIPTION */}
                
                  <div>

                    {/* TEMP */}

                    <div style={{display:'flex',justifyContent:'center',alignContent:'center',flexDirection:'row-reverse' }} >
                        <div>
                        <Typography variant="h1" style={{textAlign:'right'}} >
                            {temp.Number}
                        </Typography>

                        <Typography variant="h5" style={{textAlign:'right'}} >
                            {t(temp.description)}
                        </Typography>
                    </div>
                    <div  style={{display:'flex',justifyContent:'center',alignContent:'center'}} >

                        <img src={`https://openweathermap.org/img/wn/${temp.icon}@2x.png`} />

                    
                    </div>
                    </div>
                    
                        {/* MIN & MAX */}
                        <div style={{display:'flex',alignItems:'center',gap:'20px'}} >
                        
                          <h5> {t('max')} {temp.max}</h5>
                          <h5 style={{margin:'0px 5px'}} >|</h5>
                          <h5> {t('min')} {temp.min}</h5>
                        
                        </div>

                    {/*=== TEMP ===*/}
                    
                    
                    <div></div>

                  </div>
                  {/* DGREE & DESCRIPTION */}

                  <CloudIcon style={{fontSize:'200px'}} />

                  </div>

                </div>
                {/*=== CONTENT ===*/}
              
            </div>
            {/*=== CARD ===*/}

            {/* TRANSLATION CONTAINER */}
            <div
            dir='rtl'
            style={{
              display:'flex',
              justifyContent:'end',
              width:'100%',
              marginTop:'20px'
              }} >
            <Button variant="text" style={{color:'white'}} onClick={handleLanguageClick} >
                
                {locale == "en" ? "Arabic" : 'انجليزي'}
                </Button>
            </div>
            
            </div>
        </Container>
      </ThemeProvider>
  )
}

export default App;
